// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2emFz","savePackageButton":"ClientWallet_savePackageButton__26kLf"};